module.exports = "/images/resizepng.png?450a364ad0cc7ba3d7be8eda11f53c48";